import { OrganizationRouteNames, RouteNames } from '../../route-names';

export type MenuItem = {
  name: string;
  authenticated: boolean;
  path: string;
  roles?: [];
  blank?: boolean;
  greenland?: boolean;
};

export const MENU_ITEMS: MenuItem[] = [
  {
    name: 'Предзаказы',
    authenticated: true,
    path: RouteNames.PRE_ORDERS_PAGE,
    blank: true,
  },
  {
    name: 'Канбан',
    authenticated: true,
    path: RouteNames.KANBAN_PAGE,
  },
  {
    name: 'Архив',
    authenticated: true,
    path: RouteNames.JOURNAL_PAGE,
  },
];

export const DROPDOWN_MENU_ITEMS: MenuItem[] = [
  {
    name: 'Список компаний',
    roles: [],
    authenticated: true,
    greenland: true,
    path: OrganizationRouteNames.LIST,
  },
  {
    name: 'Управление компанией',
    roles: [],
    authenticated: true,
    greenland: false,
    path: OrganizationRouteNames.DETAILS,
  },
  {
    name: 'Каталоги',
    authenticated: true,
    path: RouteNames.CATALOGS_PAGE,
    greenland: false,
    blank: true,
  },
  {
    name: 'Отчеты',
    authenticated: true,
    path: RouteNames.REPORTS,
    greenland: true,
  },
  {
    name: 'Инвойсы и спецификации',
    authenticated: true,
    path: RouteNames.INVOICES_PAGE,
    greenland: false,
  },
];
